export default { "columns":63,
 "image":"Forest2.png",
 "imageheight":784,
 "imagewidth":1012,
 "margin":0,
 "name":"Forest2",
 "spacing":0,
 "tilecount":3087,
 "tiledversion":"1.11.1",
 "tileheight":16,
 "tiles":[
        {
         "id":488,
         "type":"Ground"
        }, 
        {
         "id":489,
         "type":"Ground"
        }, 
        {
         "id":491,
         "type":"ground"
        }, 
        {
         "id":492,
         "type":"ground"
        }, 
        {
         "id":494,
         "type":"ground"
        }, 
        {
         "id":495,
         "type":"ground"
        }, 
        {
         "id":497,
         "type":"ground"
        }, 
        {
         "id":498,
         "type":"ground"
        }, 
        {
         "id":500,
         "type":"ground"
        }, 
        {
         "id":501,
         "type":"ground"
        }, 
        {
         "id":551,
         "type":"Ground"
        }, 
        {
         "id":552,
         "type":"Ground"
        }, 
        {
         "id":554,
         "type":"ground"
        }, 
        {
         "id":555,
         "type":"ground"
        }, 
        {
         "id":557,
         "type":"ground"
        }, 
        {
         "id":558,
         "type":"ground"
        }, 
        {
         "id":560,
         "type":"ground"
        }, 
        {
         "id":561,
         "type":"ground"
        }, 
        {
         "id":563,
         "type":"ground"
        }, 
        {
         "id":564,
         "type":"ground"
        }, 
        {
         "id":740,
         "type":"ground"
        }, 
        {
         "id":741,
         "type":"ground"
        }, 
        {
         "id":743,
         "type":"ground"
        }, 
        {
         "id":744,
         "type":"ground"
        }, 
        {
         "id":746,
         "type":"ground"
        }, 
        {
         "id":747,
         "type":"ground"
        }, 
        {
         "id":752,
         "type":"ground"
        }, 
        {
         "id":753,
         "type":"ground"
        }, 
        {
         "id":803,
         "type":"ground"
        }, 
        {
         "id":804,
         "type":"ground"
        }, 
        {
         "id":806,
         "type":"ground"
        }, 
        {
         "id":807,
         "type":"ground"
        }, 
        {
         "id":809,
         "type":"ground"
        }, 
        {
         "id":810,
         "type":"ground"
        }, 
        {
         "id":815,
         "type":"ground"
        }, 
        {
         "id":816,
         "type":"ground"
        }, 
        {
         "id":849,
         "type":"Platform"
        }, 
        {
         "id":850,
         "type":"Platform"
        }, 
        {
         "id":851,
         "type":"Platform"
        }, 
        {
         "id":852,
         "type":"Platform"
        }, 
        {
         "id":1055,
         "type":"ground"
        }, 
        {
         "id":1056,
         "type":"ground"
        }, 
        {
         "id":1058,
         "type":"ground"
        }, 
        {
         "id":1059,
         "type":"ground"
        }, 
        {
         "id":1061,
         "type":"ground"
        }, 
        {
         "id":1062,
         "type":"ground"
        }, 
        {
         "id":1118,
         "type":"ground"
        }, 
        {
         "id":1119,
         "type":"ground"
        }, 
        {
         "id":1121,
         "type":"ground"
        }, 
        {
         "id":1122,
         "type":"ground"
        }, 
        {
         "id":1124,
         "type":"ground"
        }, 
        {
         "id":1125,
         "type":"ground"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};